import React from "react";
import PropTypes from "prop-types";

const Arrow = ({ className, color, direction }) => {
  switch (color) {
    case `dark-green`:
      color = `#006855`;

      break;

    case `orange`:
    default:
      color = `#EF5518`;
      break;
  }

  if (direction === `<`) {
    className = `${className} invert-x`;
  }

  //

  return (
    <svg className={className} viewBox="0 0 16 20">
      <g
        id="Symbols"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="Desktop_nav"
          transform="translate(-715.000000, -14.000000)"
          fill={color}
        >
          <polygon
            id="Fill-1"
            points="723.668915 14 721.457367 14.0017275 721.459122 30.097642 716.12157 25.9154336 715 27.0192879 722.090993 34 722.566651 34 723.040554 33.9982725 730.2 27.0192879 730.2 27.0158329 729.07843 25.9137062 723.67067 30.0959145"
          ></polygon>
        </g>
      </g>
    </svg>
  );
};

Arrow.defaultProps = {
  className: ``,
  color: `black`,
  direction: `>`
};

Arrow.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string,
  direction: PropTypes.string
};

export default Arrow;
